import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { JwtService } from 'src/app/services/jwt.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { csvDownloadServices } from 'src/app/services/csv-download.service';
import * as moment from 'moment';
import { MixpanelService } from 'src/app/services/mixpanel.service';
@Component({
  selector: 'app-documentpage',
  templateUrl: './documentpage.component.html',
  styleUrls: ['./documentpage.component.css'],
})
export class DocumentpageComponent implements OnInit {
  loaded = false;
  buttonClicked = false;
  showDeleteButton = false;
  success = false;
  status: string;
  tableHeaders: string[] = [];
  documentarchives = {
    client: null,
    year: null,
    docType: null,
    reportType: null,
    to: null,
    file: [] as any[],
  };

  collateralsForm: FormGroup;
  clients = JSON.parse(sessionStorage.getItem('clients')) || [];
  dropdownOptions = {
    to: [] as string[],
    docType: [] as string[],
    reportType: [] as string[],
    year: [] as string[],
  };

  selectAll = false;
  selectedIndices: Set<number> = new Set();
  isReport: boolean = false;
  showCollateralsData = false;
  showReportsData = false;

  constructor(
    private exportFile: csvDownloadServices,
    private api: ApiService,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private jwt: JwtService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.jwt.check();
    this.initializeForm();
    this.setupClientChangeListener();
  }

  initializeForm() {
    this.collateralsForm = this.fb.group({
      client: [null, Validators.required],
      to: [null, Validators.required],
      docType: ['', Validators.required],
      year: [null],
      reportType: [null],
    });
  }

  setupClientChangeListener() {
    this.collateralsForm.get('client')?.valueChanges.subscribe((clientId) => {
      if (clientId) {
        this.fetchDocumentArchiveDetails(clientId);
      } else {
        this.resetDropdownOptions();
      }
    });
  }

  fetchDocumentArchiveDetails(clientId: string) {
    const formData = new FormData();
    formData.append('client', clientId);

    this.api.documentarchivedetails(formData).subscribe(
      (response: any) => {
        this.dropdownOptions = {
          to: response.channelDropdown || [],
          docType: response.docTypeDropdown || [],
          reportType: response.reportTypeDropdown || [],
          year: response.yearDropdown || [],
        };
      },
      (error) => {
        this.snackbar.open('Failed to load archive details', 'Close', {
          duration: 3000,
        });
        this.resetDropdownOptions();
      }
    );
  }

  resetDropdownOptions() {
    this.dropdownOptions = {
      to: [],
      docType: [],
      reportType: [],
      year: [],
    };
  }

  onSubmit() {
    if (this.collateralsForm.valid) {
      const formValue = this.collateralsForm.value;
      const formData = new FormData();
      formData.append('client', formValue.client);
      formData.append('channel', formValue.to);
      formData.append('doctype', formValue.docType);
      if (formValue.reportType) {
        formData.append('reportType', formValue.reportType.toString());
      }
      if (formValue.year) {
        formData.append('year', formValue.year.toString());
      }

      switch (formValue.docType) {
        case 'Collaterals':
          this.api.documentarchivecollaterals(formData).subscribe(
            (response: {
              header?: string;
              table?: { header?: string[]; rows?: any[] };
              client?: string;
            }) => {
              if (response?.table) {
                this.success = true;
                this.tableHeaders = response.table.header || [];
                this.documentarchives.file = response.table.rows || [];
                this.isReport = false;
                this.showCollateralsData = true;
                this.showReportsData = false;
                this.showDeleteButton = true;

                const payload = {
                  ids:
                    this.selectedIndices.size === 0
                      ? []
                      : this.documentarchives.file
                          .map((_, index) =>
                            this.selectedIndices.has(index) ? _.id : null
                          )
                          .filter(Boolean),
                  client: response.client || 'default-client',
                };
              } else {
                this.success = false;
                this.isReport = false;
                this.showCollateralsData = false;
              }
            },
            (error) => {
              this.success = false;
              this.isReport = false;
              this.showCollateralsData = false;
            }
          );
          break;

        case 'Reports':
          this.api.documentarchivereports(formData).subscribe(
            (response: {
              header?: string;
              reportTable?: { header?: string[]; rows?: any[] };
              client?: string;
            }) => {
              if (response?.reportTable) {
                this.success = true;
                this.tableHeaders = response.reportTable.header || [];
                this.documentarchives.file = response.reportTable.rows || [];
                this.isReport = true;
                this.showReportsData = true;
                this.showCollateralsData = false;
                this.showDeleteButton = true;

                const payload = {
                  ids:
                    this.selectedIndices.size === 0
                      ? []
                      : this.documentarchives.file
                          .map((_, index) =>
                            this.selectedIndices.has(index) ? _.id : null
                          )
                          .filter(Boolean),
                  client: response.client || 'default-client',
                };
              } else {
                this.success = false;
                this.isReport = false;
                this.showReportsData = false;
              }
            },
            (error) => {
              this.success = false;
              this.isReport = false;
              this.showReportsData = false;
            }
          );
          break;

        default:
          this.success = false;
          this.isReport = false;
          this.showCollateralsData = false;
          this.showReportsData = false;
      }
    }
  }

  isSelected(index: number): boolean {
    return this.selectedIndices.has(index);
  }

  toggleSelection(index: number): void {
    if (this.selectedIndices.has(index)) {
      this.selectedIndices.delete(index);
    } else {
      this.selectedIndices.add(index);
    }
    this.updateSelectAll();
  }

  deleteSelected() {
    const confirmDeletion = window.confirm(
      'Are you sure you want to delete the selected files?'
    );
    if (!confirmDeletion) {
      return;
    }

    const filesToDelete = this.documentarchives.file
      .map((file, index) => (this.selectedIndices.has(index) ? file.id : null))
      .filter((id) => id !== null);

    if (filesToDelete.length === 0) {
      return;
    }

    const formValue = this.collateralsForm.value;
    const payload = {
      ids: filesToDelete,
      client: formValue.client,
    };

    this.api.documentarchivedelete(payload).subscribe(
      (response) => {
        this.documentarchives.file = this.documentarchives.file.filter(
          (_, index) => !this.selectedIndices.has(index)
        );
        this.selectedIndices.clear();
        this.onSubmit();
        this.selectAll = false;
        this.snackbar.open('Selected files deleted successfully', 'Close', {
          duration: 3000,
        });
      },
      (error) => {
        this.snackbar.open('Failed to delete selected files', 'Close', {
          duration: 3000,
        });
      }
    );
  }

  toggleSelectAll(): void {
    if (this.selectAll) {
      this.selectedIndices = new Set(
        this.documentarchives.file.map((_, index) => index)
      );
    } else {
      this.selectedIndices.clear();
    }

    this.updateSelectAll();
  }
  updateSelectAll(): void {
    this.selectAll =
      this.selectedIndices.size === this.documentarchives.file.length;
  }

  navigateToUploadPage() {
    this.router.navigate(['/dashboard/documentarchives/uploaddocument']);
  }

  downloadFile(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = url.split('/').pop() || 'downloaded-file';
    link.click();
  }
}
